export default __webpack_public_path__ + "static/laptop_b.fc717a73cd89b82d2c710285df136e8e.png";